"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordPolicyMessage = exports.userPasswordPolicy = exports.UserRole = void 0;
__exportStar(require("./constants"), exports);
__exportStar(require("./errors"), exports);
var UserRole;
(function (UserRole) {
    UserRole["User"] = "USER";
    UserRole["Approver"] = "APPROVER";
    UserRole["Admin"] = "ADMIN";
})(UserRole || (exports.UserRole = UserRole = {}));
exports.userPasswordPolicy = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,64})/;
exports.passwordPolicyMessage = 'Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special character (e.g. !@#$%^&*)';
